import { css } from "@emotion/react"
import { forwardRef, useRef } from "react"

import inputStyles from "./inputStyles"
import useUncontrolledAsControlled from "./useUncontrolledAsControlled"

type TextAreaProps = {
  hasError?: boolean
  value?: string
  minHeight?: number
  maxHeight?: number
  resize?: "none" | "both" | "horizontal" | "vertical" | "block" | "inline"
} & Omit<JSX.IntrinsicElements["textarea"], "value">

const TextArea = forwardRef<HTMLTextAreaElement | null, TextAreaProps>(
  ({ hasError = false, value, minHeight, maxHeight, resize = "vertical", ...restProps }, ref) => {
    const className = css(
      inputStyles.input,
      styles.textarea(minHeight, maxHeight, resize),
      restProps.disabled && inputStyles.disabled,
      hasError && inputStyles.error
    )

    const internalRef = useRef<HTMLTextAreaElement | null>(null)
    useUncontrolledAsControlled(internalRef, value)

    return (
      <textarea
        ref={(instance) => {
          internalRef.current = instance
          if (typeof ref === "function") {
            ref(instance)
          } else if (ref !== null) {
            ref.current = instance
          }
        }}
        {...restProps}
        css={className}
      />
    )
  }
)

export default TextArea

const styles = {
  textarea: (minHeight: number | undefined, maxHeight: number | undefined, resize: string) => css`
    height: 115px;
    min-height: ${minHeight ? `${minHeight}px` : "0px"};
    max-height: ${maxHeight ? `${maxHeight}px` : "auto"};
    resize: ${resize};
    /* テキストエリア下の余白を抑制するために指定 */
    vertical-align: bottom;
  `,
}
